import React from 'react'
import Button from '@/components/ui/button'
import { LinkProps } from 'next/link'

export type CustomButtonProps = {
  className?: string
  color?: string
  size?: 'xs' | 'sm' | 'xl'

  outline?: boolean
  plain?: boolean
  loading?: boolean
  unstyled?: boolean

  trackingEventName?: string
} & Omit<
  | React.HTMLProps<HTMLButtonElement>
  | (React.HTMLProps<HTMLAnchorElement> &
      LinkProps & { children?: React.ReactNode }),
  'size'
>

const CustomButton = React.forwardRef<typeof Button, CustomButtonProps>(
  function WrappedCustomButton(props, ref) {
    return <Button {...props} ref={ref} />
  }
)

export default CustomButton
